import React, { useEffect, useRef } from 'react'
import Hls from 'hls.js'

interface IStreamingVideoPlayerProps {
  playbackId: string
  classname?: string
  title?: string
  onClick?: () => void
  autoPlay?: boolean
  muted?: boolean
  playsInline?: boolean
}

export const StreamingVideoPlayer = ({
  playbackId,
  classname,
  title,
  onClick,
  autoPlay = false,
  muted = false,
  playsInline = true,
}: IStreamingVideoPlayerProps) => {
  const videoRef = useRef(null)
  const src = `https://stream.mux.com/${playbackId}.m3u8`
  const posterSrc = `https://image.mux.com/${playbackId}/thumbnail.jpg`

  useEffect(() => {
    let hls
    if (videoRef.current) {
      const video = videoRef.current

      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        // Some browsers (safari and ie edge) support HLS natively
        video.src = src
      } else if (Hls.isSupported()) {
        // This will run in all other modern browsers
        hls = new Hls()
        hls.loadSource(src)
        hls.attachMedia(video)
      } else {
        console.error("This is a legacy browser that doesn't support MSE")
      }
    }

    return () => {
      if (hls) {
        hls.destroy()
      }
    }
  }, [videoRef])

  return (
    <video
      title={title}
      onClick={onClick}
      ref={videoRef}
      className={classname ?? 'object-cover w-full h-full'}
      autoPlay={autoPlay}
      muted={muted}
      playsInline={playsInline}
      loop
      poster={posterSrc}
    />
  )
}
